import React, { ReactNode } from 'react'
import { Layout } from 'antd'
import { withRouter } from 'router'
import { Location as RouterLocation } from 'react-router'
import classNames from 'classnames'
import { useStore } from 'react-redux'

import Menu from 'components/cleanui/layout/Menu'
import TopBar from 'components/cleanui/layout/TopBar'
import { RootState } from 'redux/types'

import { getSearchParams } from 'utils'

// import naviIcon from 'assets/images/navi/toolbar-navigation.svg'

import styles from './style.module.scss'

const { Header, Content } = Layout

interface MainLayoutProps {
  children: ReactNode
  location: RouterLocation
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, location }) => {
  const store = useStore<RootState>()
  const { isDesktopSession } = store.getState().appsettings

  const params = getSearchParams()

  const hideMenu = params.hideMenu != null && params.hideMenu === 'true'
  // const _siderProps = {
  //   className: classNames(styles.sider),
  //   defaultCollapsed: true,
  //   collapsed: true,
  //   collapsable: true,
  //   collapsedWidth: 64,
  // }

  return (
    <Layout className={classNames('officemail', styles.MainLayout, { hideMenu })}>
      <Menu location={location} />
      <Layout className={classNames(styles.mainContainerWrapper)}>
        <div className={classNames(styles.mainContainer)}>
          {!isDesktopSession && (
            <Header className={classNames(styles.header)}>
              {/* <img src={naviIcon} style={{ marginLeft: '16px' }} /> */}
              <TopBar />
            </Header>
          )}
          <Content
            className={classNames(styles.content)}
            style={isDesktopSession ? { paddingTop: 12 } : undefined}
          >
            {children}
          </Content>
        </div>
      </Layout>
    </Layout>
  )
}

export default withRouter(MainLayout)
